<!--  -->
<script lang="ts" setup>
import { PaymentOrderInfo } from '@web-publish-id/payment-shared/apis/types/payment'
import { computed, ref } from 'vue'
import { formatAmount } from '@web-publish-id/shared'
import { useI18n } from 'vue-i18n'
import LockPayIcon from '../assets/svg/lock-pay.svg'

const props = defineProps<{
  orderInfo: PaymentOrderInfo
  disabled?: boolean
}>()

const { t } = useI18n()

// 支付金额
const paymentAmount = computed(() => {
  if (!props.orderInfo) return ''
  const { price, currency } = props.orderInfo
  if (!price || !currency) return ''
  return `${currency} ${formatAmount(price)}`
})

const paymentAmountText = computed(() => {
  const { price } = props.orderInfo
  if (!price) return t('t6')

  return `${t('t5')} ${paymentAmount.value}`
})
</script>

<template>
  <div :class="$style.payButton">
    <button :class="$style.payButtonInner" :disabled="disabled">
      <LockPayIcon />
      <span>{{ paymentAmountText }}</span>
    </button>
  </div>
</template>

<style lang="scss" scoped module>
.payButton {
  button {
    --button-background-color: var(--primary-color);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 0 16px;
    min-width: 80px;
    height: 32px;
    background-color: var(--button-background-color);
    color: #fff;
    border: none;
    border-radius: 5px;
    text-decoration: none;
    transition: background 0.3s ease-out, box-shadow 0.3s ease-out;
    cursor: pointer;

    &:hover {
      --button-background-color: #6b73e6;
    }

    &.line {
      color: var(--primary-color);
      border: 1px solid var(--primary-color);
      --button-background-color: #ffffff;

      &:hover {
        --button-background-color: #f1f1f1;
      }
    }
  }

  button.payButtonInner {
    --shadow-color: transparent;
    position: relative;
    border: 0;
    border-radius: 8px;
    width: 100%;
    height: 48px;
    background: linear-gradient(270deg, #8742ff 0%, #4800ff 100%);
    box-shadow: inset 0px 2px 4px 0px rgba(255, 255, 255, 0.25);
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    overflow: hidden;
    cursor: pointer;

    svg {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--shadow-color);
      transition: all 0.3s ease;
      z-index: 0;
    }

    &:hover {
      --shadow-color: rgba(255, 255, 255, 0.25);
    }

    &:active {
      --shadow-color: rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      --shadow-color: rgba(255, 255, 255, 0.75);
      cursor: not-allowed;
    }
  }
}
</style>
